import { Flex, Text, Button, Box, Dialog } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import { AlertTriangleIcon, IconEast } from 'shared/icons';

export const ResumeLockScreen = ({ mode }: { mode?: 'dialog' }) => (
   <Box className="">
      <Flex
         align="center"
         mt="6"
         justify="center"
         direction="column"
         minHeight="240px"
         gap="3"
         px="4"
      >
         <Flex>
            <AlertTriangleIcon width={60} height={60} color="orange" />
         </Flex>

         <Text align="center" size="4">
            Будь ласка, заповніть поля у профілі, щоб мати можливість створити резюме
         </Text>

         {mode === 'dialog' ? (
            <Dialog.Close >
               <Button size="3" mt="4">
                  Закрити
               </Button>
            </Dialog.Close>
         ) : (
            <Button asChild size="3" color="blue" highContrast mt="4">
               <Link to="/candidate/profile">
                  Перейти до профілю <IconEast></IconEast>
               </Link>
            </Button>
         )}
      </Flex>
   </Box>
);
